import React, { useEffect, useState } from 'react'
import { GetASD, GroupByPropCheck } from '../../Finanzas/Actions/GetContainer';
import { TextField } from '@mui/material';

export const FiltroBuscadorListadoPrecio = ({ data, datafiltro, setDatafiltro, filtrar, setFiltrar, keyFiltrado }) => {
    const [predictivo, setPredictivo] = useState("");
    const [state, setState] = useState([])
    // const [arrayClientes, setArrayClientes] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        sucursal: [],
        promocion: [],
        estatus: [],
        ejercicio: [],
        modelo: [],
        hp: [],
    });


    useEffect(() => {
        const filteredData = data.filter(item => {
            // console.log("Comparando sucursal:", item.tiene_promocion, selectedFilters.promocion);
            return (
                (selectedFilters.sucursal.length === 0 || selectedFilters.sucursal.map(Number).includes(item.sucursal)) &&
                (selectedFilters.promocion.length === 0 || selectedFilters.promocion.includes(item.tiene_promocion)) &&
                (selectedFilters.estatus.length === 0 || selectedFilters.estatus.includes(item.estatus)) &&
                (selectedFilters.ejercicio.length === 0 || selectedFilters.ejercicio.includes(item.ejercicio)) &&
                (selectedFilters.modelo.length === 0 || selectedFilters.modelo.includes(item.modelo)) &&
                (selectedFilters.hp.length === 0 || selectedFilters.hp.includes(item.hp))
            );
        });

        if (selectedFilters.estatus.length > 0) {
            setState(filteredData)
        }

        setDatafiltro(filteredData);
    }, [selectedFilters, data]);

    useEffect(() => {
        if (filtrar) {
            if (keyFiltrado === "T") {
                setSelectedFilters({ ...selectedFilters, estatus: [] })
                setFiltrar(false);
            }
            else {
                handleFilterStateChange('estatus', keyFiltrado);
                setFiltrar(false);
            }
        }
    }, [filtrar]);

    // Función para manejar el filtro de estus (en caso de usar la logica anterior, solo se manda a llamar handleFilterChange)
    const handleFilterStateChange = (filterName, value) => {
        setSelectedFilters(prevState => {
            const currentValues = prevState[filterName];
            if (currentValues.includes(value)) {
                return {
                    ...prevState,
                    [filterName]: currentValues.filter(item => item !== value),
                };
            }
            else {
                return {
                    ...prevState,
                    [filterName]: [value],
                };
            }
        });
    };

    useEffect(() => {

        const dataToFilter = selectedFilters.estatus.length > 0 ? state : data;
        const result = dataToFilter.filter((item) => {
            // Convertimos item.ejercicio a string si es un número
            const ejercicioStr = item.ejercicio ? item.ejercicio.toString() : '';  // Convertimos a string
            const hpStr = item.hp ? item.hp.toString() : '';
            const horaStr = item.horas ? item.horas.toString() : '';


            return (
                item.modelo_descripcion?.toUpperCase().includes(predictivo.toUpperCase()) ||
                item.modelo?.toUpperCase().includes(predictivo.toUpperCase()) ||
                item.marca?.toUpperCase().includes(predictivo.toUpperCase()) ||
                item.nombre_sucursal?.toUpperCase().includes(predictivo.toUpperCase()) ||
                ejercicioStr.includes(predictivo) ||
                hpStr.includes(predictivo) ||
                horaStr.includes(predictivo) ||
                item.ne.includes(predictivo)
            );
        });

        console.log(result); // Verificar el resultado del filtro
        setDatafiltro(result);
    }, [predictivo, state, data, selectedFilters]);  // Asegúrate de que todas las dependencias estén aquí



    return (
        <div className='listado-precios-usados-buscador-container'>
            <div className="listado-clientes-gestionar-header-control">
                <TextField
                    color="success"
                    fullWidth
                    size="small"
                    value={predictivo}
                    onChange={({ target }) => setPredictivo(target.value)}
                    placeholder="Buscar por Modelo, Tractor, Sucursal..."
                />
            </div>
        </div>
    )
}
